module.exports = __webpack_public_path__ + "img/dirty-edit-plotting.a2d79dd1.svg";